import { INTEGRATION_API } from "./constants.js";

export const getTicketOrderData = async (orderIds) => {
  try {
    const response = await fetch(
      `${INTEGRATION_API.baseUrl}${INTEGRATION_API.endpoints.ticketOrder}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ orderIds })
      }
    );

    const responseObject = await response.json();

    let orderType;

    orderType = responseObject.orderData.every((order) =>
      order.tickets.every((ticket) => ticket.price === "0")
    )
      ? "registration"
      : "purchase";

    if (
      responseObject.orderData.some((order) => {
        return order.tickets.some((ticket) => {
          return ticket.name.indexOf("Request") > -1 || ticket.ticketType.indexOf("Request") > -1;
        });
      })
    ) {
      orderType = "request";
    }

    const orderData = {
      ...responseObject.orderData.reduce(
        (acc, order) => {
          acc.tickets.push(...order.tickets);
          acc.orderIds.push(order.orderId);
          acc.orderDates.push(order.orderDate);
          acc.orderNumbers.push(order.orderNumber);
          return acc;
        },
        { tickets: [], orderIds: [], orderDates: [], orderNumbers: [] }
      ),
      relatedTours: responseObject.tours,
      relatedEvents: responseObject.events,
      orderType
    };

    return orderData;
  } catch (error) {
    console.error("Error fetching ticket order data:", error);
    throw error;
  }
};
